Date.now ||
  (Date.now = function() {
    return +new Date();
  });



//////////////////
// WEBPACK FOOTER
// ./client/vendor/date-now-polyfill.js
// module id = miCJ
// module chunks = 15